import { useEffect, useRef, useState, type RefObject } from "react";

/**
 * Tracks an element's pixel width via ResizeObserver, so an SVG chart can lay
 * out points in real pixels and stay crisp as the panel resizes.
 */
export function useElementSize<T extends HTMLElement>(): [RefObject<T>, { width: number }] {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new ResizeObserver((entries) => {
      setWidth(entries[0].contentRect.width);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return [ref, { width }];
}
